export const BRAND = {
    name: "Borges Cargas",
    tagline: "Transportando com Excelência",
    instagram: "@borgescargas",
    instagramUrl: "https://instagram.com/borgescargas",
};

export const WHATSAPP_NUMBER_DISPLAY = "+55 85 98109-0149";
export const WHATSAPP_NUMBER = "5585981090149";

export const waLink = (message) =>
    `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const DEFAULT_QUOTE_MESSAGE =
    "Olá! Vim pelo site da Borges Cargas e quero uma cotação de frete.";

export const IMAGES = {
    heroBg:
        "https://images.unsplash.com/photo-1635822279175-67270a5bffcb?q=80&w=2200&auto=format&fit=crop",
    heroCard:
        "https://images.unsplash.com/photo-1745956983820-6e960f7e8472?q=80&w=1400&auto=format&fit=crop",
    fracionadas:
        "https://images.unsplash.com/photo-1648500434498-5a1d4ed1e3d6?q=80&w=1400&auto=format&fit=crop",
    armazenagem:
        "https://images.unsplash.com/photo-1689942010216-dc412bb1e7a9?q=80&w=1400&auto=format&fit=crop",
    distribuicao:
        "https://images.unsplash.com/photo-1696592783645-33e966c4c274?q=80&w=1400&auto=format&fit=crop",
    lotacao:
        "https://images.unsplash.com/photo-1578857371787-189d8b9eda84?q=80&w=1400&auto=format&fit=crop",
};

export const SERVICES = [
    {
        id: "fracionadas",
        testid: "service-card-cargas-fracionadas",
        title: "Cargas Fracionadas",
        tag: "LTL",
        badge: "Mais solicitado",
        description:
            "Seu volume divide espaço no veículo e você paga só pelo que usa. Consolidação inteligente e rotas diárias para reduzir o custo por quilo.",
        image: IMAGES.fracionadas,
        span: "lg:col-span-7",
    },
    {
        id: "lotacao",
        testid: "service-card-cargas-lotacao",
        title: "Carga Lotação",
        tag: "FTL",
        badge: "Frota exclusiva",
        description:
            "Veículo dedicado exclusivamente à sua carga, direto da origem ao destino, sem baldeações e com o prazo mais curto possível.",
        image: IMAGES.lotacao,
        span: "lg:col-span-5",
    },
    {
        id: "armazenagem",
        testid: "service-card-armazenagem",
        title: "Armazenagem",
        tag: "WAREHOUSE",
        badge: "Estoque seguro",
        description:
            "Estoque sob controle em galpão seguro, com inventário organizado, cross-docking e expedição no prazo combinado.",
        image: IMAGES.armazenagem,
        span: "lg:col-span-5",
    },
    {
        id: "distribuicao",
        testid: "service-card-distribuicao",
        title: "Distribuição Última Milha",
        tag: "LAST MILE",
        badge: "Entrega expressa",
        description:
            "Entregas urbanas e na região metropolitana com roteirização inteligente para e-commerce e varejo, até a porta do seu cliente.",
        image: IMAGES.distribuicao,
        span: "lg:col-span-7",
    },
];

export const serviceQuoteLink = (title) =>
    waLink(
        `Olá! Vim pelo site da Borges Cargas e quero uma cotação de ${title}.`,
    );

// DEPOIMENTOS: conteúdo de EXEMPLO (placeholders) — trocar por depoimentos reais
// enviados pelo cliente antes de considerar definitivo.
export const TESTIMONIALS = [
    {
        id: 1,
        name: "Marcos R.",
        city: "Brasília - DF",
        text: "Precisei enviar mercadoria de Brasília para São Paulo com urgência e a Borges Cargas resolveu no mesmo dia. Cuidado com a carga do início ao fim.",
    },
    {
        id: 2,
        name: "Juliana S.",
        city: "Goiânia - GO",
        text: "Toda semana movemos nossa produção com eles. Pontualidade e comunicação durante o trajeto são os pontos fortes.",
    },
    {
        id: 3,
        name: "Carlos M.",
        city: "Salvador - BA",
        text: "Contratei para a distribuição na região e as entregas chegaram dentro do combinado. Recomendo para quem precisa de prazo cumprido.",
    },
];

export const HQ = {
    city: "Brasília",
    state: "DF",
    tagline: "Sede em Brasília (DF) · Atendimento em todo o Brasil",
};

export const EMAIL = "atendimento@borgescargas.com";

export const buildQuoteMessage = (form) =>
    [
        "Olá! Vim pelo site da Borges Cargas e quero uma cotação.",
        `• Serviço: ${form.servico}`,
        `• Origem: ${form.origem}`,
        `• Destino: ${form.destino}`,
        `• Peso aproximado: ${form.peso || "a informar"}`,
    ].join("\n");

export const mailtoQuoteLink = (form) => {
    const subject = "Cotação de frete — Borges Cargas";
    return `mailto:${EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(buildQuoteMessage(form))}`;
};

